
export enum CalendarEventKind {
    DocumentDueDate = 'DocumentDueDate',

    /// <summary>
    /// Termin rozliczenia VAT
    /// </summary>
    VATSettlement = 'VATSettlement',

    /// <summary>
    /// Termin rozliczenia VATUE
    /// </summary>
    VATUESettlement = 'VATUESettlement',

    /// <summary>
    /// Termin rozliczenia ZUS
    /// </summary>
    ZUSSettlement = 'ZUSSettlement',

    /// <summary>
    /// Termin płatności podatku w formie karty podatkowej (miesiące styczeń-listopad)
    /// </summary>
    IncomeTaxSettlement_KP = 'IncomeTaxSettlement_KP',

    /// <summary>
    /// Termin płatności podatku w formie karty podatkowej (za miesiąc grudzień)
    /// </summary>
    IncomeTaxSettlement_KP_Annual = 'IncomeTaxSettlement_KP_Annual',

    /// <summary>
    /// Termin złożenia deklaracji PIT-16A (działalność opodatkowana kartą podatkową)
    /// </summary>
    IncomeTaxSettlement_KP_PIT16A = 'IncomeTaxSettlement_KP_PIT16A',

    /// <summary>
    /// Termin płatności zaliczki na podatek dochodowy (KPiR)
    /// </summary>
    IncomeTaxSettlement_KPiR = 'IncomeTaxSettlement_KPiR',

    /// <summary>
    /// Termin rozliczenia zeznania rocznego (KPiR)
    /// </summary>
    IncomeTaxSettlement_KPiR_Annual = 'IncomeTaxSettlement_KPiR_Annual',

    /// <summary>
    /// Termin płatności zryczałtowanego podatku od przychodów ewidencjonowanych (styczeń-listopad lub kwartały I-III)
    /// </summary>
    IncomeTaxSettlement_RE = 'IncomeTaxSettlement_RE',

    /// <summary>
    /// Termin płatności ryczałtu od przychodów ewidencjonowanych (grudzień lub IV kwartał)
    /// </summary>
    IncomeTaxSettlement_RE_Annual = 'IncomeTaxSettlement_RE_Annual',

    /// <summary>
    /// Termin wysyłki JPK FA i VAT
    /// </summary>
    JPKSendDate = 'JPKSendDate',
}
